// Role names exactly as the brand book writes them.
export type Role = 'Renewal VA' | 'Account Executive' | 'Manager' | 'Admin';

// The codes the server stores and sends (packages/db/src/roles.ts), mapped to those names.
export type RoleCode = 'renewal_va' | 'account_executive' | 'manager' | 'admin';

export const roleLabels: Record<RoleCode, Role> = {
  renewal_va: 'Renewal VA',
  account_executive: 'Account Executive',
  manager: 'Manager',
  admin: 'Admin',
};

export const managesDepartment = (role: Role) => role === 'Manager' || role === 'Admin';

// The Renewal VA only has My renewals.
export const seesAllRenewals = (role: Role) => role !== 'Renewal VA';

// Subtitles from the Renewals board, per role.
export function renewalsSubtitle(page: 'my' | 'all', role: Role): string {
  if (role === 'Renewal VA') return 'Your renewals in the 45-day window';
  if (role === 'Account Executive') {
    return page === 'my'
      ? 'Your handoffs, the renewals you handle and what you finished'
      : 'Renewals on your accounts in AMS360';
  }
  return page === 'my' ? 'Renewals you took over yourself' : 'Every renewal in the Home department';
}
